import styles from './Approvers.module.css';

const Approver = ({ name }) => {
  return <div className={styles['approver']}>{name}</div>;
};

export default Approver;
